import React from 'react';
import classNames from 'classnames';

import styles from './InfoBox.module.scss';

type Variant = 'info' | 'warning' | 'danger';

interface Props {
    variant?: Variant;
    title?: string;
    message?: React.ReactNode;
    className?: string;
}

const InfoBox = ({ variant = 'info', title, message, className }: Props) => {
    return (
        <div className={classNames(styles.root, styles[variant], className)}>
            <div className={styles.content}>
                {title && <strong>{title}</strong>}
                {message && <div className={styles.message}>{message}</div>}
            </div>
        </div>
    );
};

export default InfoBox;
